import PopupComponent from './PopupComponent';
import each from 'lodash/each';
export default class LangPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--lang',
			elements: {
				description: '.popup__main-text',
				img: '.popup__image-cover',
				btnBackToSite: '#back-to-site',
				btns: '[data-lang-code]',
				langSvgNav: document.querySelector('#lang-svg-nav'),
				jarText: document.querySelector('.nav__jar-text'),
			},
		});
		this.activeLang = window.locale;
		console.log(this.elements.btns);
	}

	addEventListeners() {
		super.addEventListeners();
		this.elements.btnBackToSite.addEventListener('click', () => {
			this.hide();
		});
	}

	setActiveLang() {
		this.activeLang = window.locale;
		each(this.elements.btns, (btn) => {
			btn.classList.remove('btn--active');
			const langCode = btn.getAttribute('data-lang-code');
			if (langCode === this.activeLang) {
				btn.classList.add('btn--active');
			}
		});
		this.elements.langSvgNav.src = `images/${this.activeLang}f.svg`;
		// const textTranslations = {
		// 	en: 'Donate To Artist',
		// 	de: 'Spenden an den Künstler',
		// 	nl: 'Doneer aan de artiest',
		// };
		// this.elements.jarText.textContent =
		// 	textTranslations[this.activeLang] || textTranslations['en'];
	}

	show() {
		super.show();
		this.$emit('stopScroll');
	}

	hide(startScroll = true) {
		super.hide();
		if (startScroll) this.$emit('startScroll');
	}
}
